import { useEffect } from 'react';
import { Platform } from 'react-native';
import * as NavigationBar from 'expo-navigation-bar';

/**
 * Based on https://kirillzyusko.github.io/react-native-keyboard-controller/docs/api/hooks/keyboard/use-keyboard-handler.
 *
 * However, this library actually enables us to animated the components as the keyboard changes position, so it would
 * be nice if we migrated to using that.
 */
export default function useNavigationBarStyle(style: 'light' | 'dark') {
  useEffect(() => {
    if (Platform.OS === 'android') {
      NavigationBar.setButtonStyleAsync(style);
    }
  }, [style]);
}
